import { render, staticRenderFns } from "./DialogBatchUpdate.vue?vue&type=template&id=49987bc8"
import script from "./DialogBatchUpdate.vue?vue&type=script&lang=js"
export * from "./DialogBatchUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports